import { durationMins } from './formatTime';

export function computeShiftCost(shift, employee) {
  if (!shift || shift.isOff || !shift.startTime || !shift.endTime) {
    return { minutes: 0, costSmallestUnit: 0 };
  }
  const mins = durationMins(shift.startTime, shift.endTime);
  const hourlyRate = employee?.hourlyRateCost ?? 0;
  return {
    minutes: mins,
    costSmallestUnit: Math.round((mins / 60) * hourlyRate),
  };
}

export function aggregateDailyCosts(shifts, employees) {
  const empMap = new Map((employees ?? []).map((e) => [e.id, e]));
  const result = new Map();
  for (const shift of shifts ?? []) {
    if (shift.isOff) continue;
    const emp = empMap.get(shift.employeeId);
    const { minutes, costSmallestUnit } = computeShiftCost(shift, emp);
    if (minutes === 0) continue;
    const existing = result.get(shift.shiftDate) ?? { minutes: 0, costSmallestUnit: 0 };
    result.set(shift.shiftDate, {
      minutes: existing.minutes + minutes,
      costSmallestUnit: existing.costSmallestUnit + costSmallestUnit,
    });
  }
  return result;
}
